/**
 * 2007-2018 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2018 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import zoom from 'jquery-zoom';

import { mobileCheck } from './utils';


$(document).ready(function () {
  createProductSpin();
  createInputFile();
  initProductPageSlider();
  initColorPickerSlider();
  initZoom();
  setProductTabs();
  checkIfMailAlertAvalibleHideAddtocart();
  initMobileCommentsSlider();

  setProductAvability();

  $('[data-toggle="tooltip"]').tooltip();

  $(document).on('click', '.commentsBlock__expandComment', function(e) {
    e.preventDefault();

    const $self = $(this),
          $commnetBlock = $self.closest('.commentsBlock__comment'),
          btnText = $self.attr('data-text');


    $self.attr('data-text', $self.text()).text(btnText);
    $commnetBlock.toggleClass('commentsBlock__comment--expanded');

  });



  prestashop.on('updatedProduct', function (event) {
    createInputFile();
    


    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      const quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    $('.js-product-images-modal').replaceWith(event.product_images_modal);
    initProductPageSlider();
    selectColorPickerImg();
    initZoom();
    setProductAvability();
    checkIfMailAlertAvalibleHideAddtocart();
    $('body').removeClass('productUpdating');
  });

  $(document).on('change', '.product-variants select', function() {
    $('body').addClass('productUpdating');
  })


  function setProductAvability() {
    const $productDetails = $('#product-details'),
          productAvailability = $productDetails.data('productavailability'),
          $productAddToCart = $('.product-add-to-cart');
    
    //console.log($('#quantity_wanted').val()+" "+$('#product-details').data('productquantity'));
    if($('#quantity_wanted').val() >= $('#product-details').data('productquantity')){
      //disable up
      $('.bootstrap-touchspin-up').attr('disabled',true);
    }
    else{
      //enable up
      $('.bootstrap-touchspin-up').attr('disabled',false);
    }

    if(productAvailability) {
      $productAddToCart.removeClass('addToCart--disabled');
    } else {
      $productAddToCart.addClass('addToCart--disabled');
    }
  }
  function initZoom(){
    console.log('initZoom');
    $('.slick-active > .js-thumb').parent().zoom({
      on:'click',
      touch: true,
      url: $('.slick-active > .js-thumb').data('image-large-src'),
      onZoomIn: function(){
        $(this).addClass('zoomed');
      },
      onZoomOut: function(){
        $(this).removeClass('zoomed');
      }
    });
  }

  //not used
  /*function coverImage() {
    $('.js-thumb').on(
      'load',
      (event) => {
        $(event.target).parent().zoom({
          on:'click',
          touch: true,
          url: $(event.currentTarget).data('image-large-src'),
          onZoomIn: function(){
            $(this).addClass('zoomed');
          },
          onZoomOut: function(){
            $(this).removeClass('zoomed');
          }
        });

      }
    );
  }*/

  $(document).on('click', '.colorPicker .colorPicker__color', function() {

    const $this = $(this),
          $select = $('[name="' + $this.attr('data-name') + '"]'),
          value = $this.attr('data-value'),
          $list = $('.colorPicker .colorPicker__color');

    if($select.val() != value) {
      $select.val(value).trigger('change');
      $list.removeClass('selected');
      $this.addClass('selected');
    }

  });

  $(document).on('click', '.productVideo__btn', function(e) {
    e.preventDefault();
    showProductVideo();
  });
  $(document).on('click', '.productImages__block--thumbs .thumb-container', hideProductVideo);

  function showProductVideo() {
    const $mainImagesBlock = $('.productImages__block--cover'),
          $videoBlock = $('.productImages__video'),
          $videoIframe = $videoBlock.find('iframe'),
          videoSrc = $videoBlock.data('video');


    // IF VIDEO IS ACTIVE AND IS MOBILE
    if($(window).innerWidth() < 576) {
      const $showVideBtn = $('.productVideo__btn'),
            $btnSpan = $showVideBtn.find('span'),
            btnText = $btnSpan.text(),
            btnSwapText = $btnSpan.attr('data-text');

      $btnSpan.attr('data-text', btnText);
      $btnSpan.text(btnSwapText);
      if($mainImagesBlock.hasClass('productImages__block--videoActive')) {
        hideProductVideo();
        return;
      }
    }


    $videoIframe.attr('src' ,videoSrc);

    $mainImagesBlock.addClass('productImages__block--videoActive');

    const videBlockWidth = $videoBlock.width(),
          videoRatio = $videoIframe.attr('width')/$videoIframe.attr('height');

    $videoIframe.css({
      width: videBlockWidth + 'px',
      height: videBlockWidth/videoRatio + 'px'
    });
    $videoBlock.css({
      height: videBlockWidth/videoRatio + 'px'
    });

    setEventsForViemoIframe();
  }

  function setEventsForViemoIframe() {
    const $iframePlayer = $('.productImages__video iframe'),
          player = new Vimeo.Player($iframePlayer[0]);

    player.on('ended', function() {
      hideProductVideo();
    });
  }

  function hideProductVideo() {
    const $mainImagesBlock = $('.productImages__block--cover'),
          $videoIframe = $('.productImages__video iframe');

          $videoIframe.attr('src', '');

    $mainImagesBlock.removeClass('productImages__block--videoActive');
  }

  function createInputFile()
  {
    $('.js-file-input').on('change', (event) => {
      let target, file;

      if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
        $(target).prev().text(file.name);
      }
    });
  }

  function createProductSpin()
  {
    const $quantityInput = $('#quantity_wanted');
    $quantityInput.TouchSpin({
      verticalbuttons: true,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: parseInt($quantityInput.attr('min'), 10),
      max: 1000000
    });

    $('body').on('change keyup', '#quantity_wanted', (e) => {

      $('body').addClass('productUpdating');
      $('.add-to-cart').attr('disabled',true);

      $(e.currentTarget).trigger('touchspin.stopspin');
      prestashop.emit('updateProduct', {
          eventType: 'updatedProductQuantity',
          event: e
      });
    });
  }

  function initProductPageSlider() {
    const $bigSlider = $('.productImages__list--big'),
          $navSlider = $('.productImages__list--thumbs'),
          isMobile = $(window).innerWidth() < 576 ? true : false;

    let backActive = false;


    $navSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
      if($(slick.$slides[slick.$slides.length - 1]).hasClass('slick-active')) {
        backActive = true;
      } else if ($(slick.$slides[0]).hasClass('slick-active')) {
        backActive = false;
      }

      if(backActive) {
        $navSlider.addClass('goBack');
      } else {
        $navSlider.removeClass('goBack');
      }
    });


    if(isMobile) {
      $bigSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: false,
        mobileFirst: true
      });
    } else {
      $bigSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
    		infinite: false,
        asNavFor: '.productImages__list--thumbs'
      });

      $navSlider.slick({
        slidesToShow: 4,
    		slidesToScroll: 1,
    		asNavFor: '.productImages__list--big',
    		dots: false,
    		arrows: true,
    		centerMode: false,
    		vertical: true,
    		focusOnSelect: true,
    		infinite: false
      });
      // FIX FOR SLICK HEIGHT BUG??
      setTimeout(function() {
        $navSlider.slick('setPosition');
      },500);
    }
    //FIX FOR ZOOM ON CHANGE SLIDE
    $bigSlider.on('afterChange', function(){    
      $('.slick-active > img').trigger('zoom.destroy');
      initZoom();
    });

  }

  function selectColorPickerImg() {
    const $colorPickerColors = $('.colorPicker .colorPicker__color'),
          $colorSelect = $('#group_' + $colorPickerColors.attr('data-product-attribute')),
          selectedValue = $colorSelect.val();

    $colorPickerColors.removeClass('selected');
    $('.colorPicker').find('[data-value="' + selectedValue + '"]').addClass('selected');
  }

  function initColorPickerSlider() {
    const isMobile = $(window).innerWidth < 992 ? true : false,
          $colorPickerList = $('.colorPicker__list');

    let backActive;

    if(!isMobile) {

      $colorPickerList.on('afterChange', function(event, slick, currentSlide, nextSlide) {
        if($(slick.$slides[slick.$slides.length - 1]).hasClass('slick-active')) {
          backActive = true;
        } else if ($(slick.$slides[0]).hasClass('slick-active')) {
          backActive = false;
        }

        if(backActive) {
          $colorPickerList.addClass('goBack');
        } else {
          $colorPickerList.removeClass('goBack');
        }
      });

      $colorPickerList.slick({
    		slidesToScroll: 1,
        slidesToShow: 11,
        variableWidth: true,
    		dots: false,
    		arrows: true,
    		infinite: false,
        responsive: [
          {
            breakpoint: 1350,
            settings: {
              slidesToShow: 9,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 1
            }
          }
        ]
      })
    }
  }


  function setProductTabs() {
    const isMobile = $(window).innerWidth() >= 768 ? false : true,
          $productTabs = $('.productTabs'),
          $productNavItems = $productTabs.find('.nav-item a'),
          $firstNav = $productTabs.find('.nav-tabs .nav-item:first-child a');


    if(!isMobile) {
      $firstNav.trigger('click');
    }

    $productNavItems.each(function() {
      const $self = $(this),
            title = $self.attr('title'),
            $panel = $($self.attr('href')),
            $backBtn = '<div class="mobile-back"><span class="mobile-back-title">' + title + '</span></div>'


      $panel.prepend($backBtn);

    });

    $(document).on('click', '.productTabs .mobile-back', function() {
      const $self = $(this),
            $parent = $self.parent(),
            $body = $('body');

      $productTabs.find('.nav-item [href="#' + $parent.attr('id') + '"]' ).removeClass('active');
      $parent.removeClass('active');
      $body.removeClass('fixedHeight');
      $self.css('top', ''); // RESET VALUE
      $parent.scrollTop(0); // RESET SCROLL
    })

  }

  $('.productTabs .nav-item a').on('shown.bs.tab', function (e) {
    if($(window).innerWidth() < 768) {
      $('body').addClass('fixedHeight');
    }
  });

  $('.productTabs.tabs .tab-pane').on('scroll', function() {
    const $self = $(this),
          $fixedBack = $self.find('.mobile-back');

    $fixedBack.css('top', $self.scrollTop() + 'px');

  });


  function checkIfMailAlertAvalibleHideAddtocart() {
    const $mailAlertBlock = $('.js-mailalert ');
    const $addToCartBlock = $('.product-add-to-cart');

    if($mailAlertBlock.length > 0) {
      $addToCartBlock.addClass('addToCart--disabled');
    } else {
      $addToCartBlock.removeClass('addToCart--disabled');
    }
  }


  function initMobileCommentsSlider() {
    const isMobile = mobileCheck(768),
          $recentCommentsList = $('.commentsBlock__row'),
          isSliderInitialized = $recentCommentsList.hasClass('slick-slider');

    if(isMobile) {

      if(!isSliderInitialized) {
        $recentCommentsList.slick({
          dots: true,
          infinite: false,
          speed: 600,
          autoplay: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }

    } else {
      if(isSliderInitialized) {
        $recentCommentsList.slick('unslick');
      }
    }
  }

  $(window).on('resize', initMobileCommentsSlider);




});
